// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import Button, {
  type ButtonProps,
} from "metabase/common/components/Button/Button";
import { breakpointMaxSmall } from "metabase/styled-components/theme";

export const NewButton = styled((props: ButtonProps) => (
  <Button {...props} iconSize={props.iconSize ?? 16} />
))`
  display: flex;
  align-items: center;
  height: 2.25rem;
  padding: 0.5rem;
  border-radius:3em;
  border: #cececeff 1px solid;
  color: black;
  background-color: #ffffffff;
  position: relative;

  &:before{
  content:'';
  width: 30px;
  height: 30px;
  background-color: #03406C;
  border-radius: 100%;
  position: absolute;
  left: 3px;
  z-index:0;
  
  }

  &:hover{
  background-color: #03406C;
  border: #03406C 1px solid;
  }

  ${Button.TextContainer} {
    margin-left: 0;
    // z-index: 20;
  }

  ${breakpointMaxSmall} {
    display: none;
  }
`;

export const NewButtonText = styled.h4`
  display: inline;
  margin-left: 0.5rem;
  white-space: nowrap;
  position: relative;
  z-index: 10;
`;
